import { ajax } from '@/plugins/ajax'

export default {
  namespaced: true,
  state: {
    list: [],
  },
  getters: {
    list: (state) => state.list,
  },
  actions: {
    fetchSearch({ commit, dispatch }, name) {
      return new Promise((resolve, reject) => {
        ajax.get('Inventory/api/StockQuery/' + name +'/0').then(r => {
          resolve(r.data);
        }).catch(e => {
          reject(e.response.data)
        });
      })
    },
    update({ commit, dispatch }, model) {
      return ajax.put('Inventory/api/Stock', model)
    },
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    },
  
  }
}
